/**
 * @Author          : ZhangLianWei
 * @Date            : 2024-07-01 18:03:42
 * @LastEditors     : SuXiao xiao.su_ext@novartis.com
 * @LastEditTime    : 2025-06-24 18:20:58
 * @FilePath        : \wecom-front-end-admin-portal\src\services\nuoxiaoer-service.ts
 * @Description     :
 * @
 */
import {Inject} from '@cds/common';
import {HttpService} from '@/services/common/http.service';
import { AxiosResponse, AxiosRequestConfig } from 'axios';

export class NuoxiaoerService {
  @Inject(HttpService) private http!: HttpService;
  //添加
  public articleAdd(param: Dict<any>): Promise<any> { //wecom-buddy-backend/api/article/admin/queryArticleList
    return this.http.post('/wecom-buddy-backend/api/article/admin/addArticle', param);
  }
  //查询
  public queryArticleList(param: Dict<any>): Promise<any> {
    return this.http.post('/wecom-buddy-backend/api/article/admin/queryArticleList', param);
  }
  //详情
  public queryArticleInfo(id: Dict<any>): Promise<any> {
    return this.http.get(`/wecom-buddy-backend/api/article/admin/detail/${id}`);
  }
  //删除
  public queryArticleDelete(param: Dict<any>): Promise<any> {
    return this.http.post('/wecom-buddy-backend/api/article/admin/deleteArticleById', param);
  }
  //删除
  public updateArticleById(param: Dict<any>): Promise<any> {
    return this.http.post('/wecom-buddy-backend/api/article/admin/updateArticleById', param);
  }
  //根据所属类型获取应用/业务场景名称
  public queryAppOrScenarioByType(param: Dict<any>): Promise<any> {
    return this.http.post('/wecom-buddy-backend/api/article/admin/queryAppOrScenarioByType', param);
  }
  //根据所属类型获取应用/业务场景名称
  public querySecondMenuByAppOrScenarioId(param: Dict<any>): Promise<any> {
    return this.http.post('/wecom-buddy-backend/api/article/admin/querySecondMenuByAppOrScenarioId', param);
  }

  public fetchCommonConfig(param: Dict<any>): Promise<any> {
    return this.http.get('/wecom-buddy-backend/api/config/configurations', param);
  }

  public fetchUserActions(param: Dict<any>): Promise<any> {
    return this.http.post('/wecom-buddy-backend/api/user/getHistoryInfo', param);
  }
  //文库模块管理列表
  public fetchLibraryModuleList(param: Dict<any>): Promise<any> {
    return this.http.post('/wecom-buddy-backend/api/manager/cover/list', param);
  }

  //文库模块管理详情
  public libraryModuleDetail(param: Dict<any>): Promise<any> {
    return this.http.get('/wecom-buddy-backend/api/manager/cover/detail', param);
  }

  //文库模块保存
  public saveLibraryModule(param: Dict<any>): Promise<any> {
    return this.http.post('/wecom-buddy-backend/api/manager/cover/add', param);
  }

  //文库模块更新
  public updateLibraryModule(param: Dict<any>): Promise<any> {
    return this.http.post('/wecom-buddy-backend/api/manager/cover/upd', param);
  }
  
  //文库模块删除
  public deleteLibraryModule(param: Dict<any>, conf): Promise<any> {
    return this.http.post('/wecom-buddy-backend/api/manager/cover/del?id=' + param.id, {}, null, conf);
  }

  //获取BU列表
  public getBUList(): Promise<any> {
    return this.http.get('/wecom-buddy-backend/api/manager/common/user/bu/list');
  }

  //获取用户分组
  public fetchUserGroupList(param: Dict<any>): Promise<any> {
    return this.http.get('/wecom-buddy-backend/api/manager/common/user/groups', param);
  }

  // 获取所属模块
  public fetchModuleList(param: Dict<any>): Promise<any> {
    return this.http.get('/wecom-buddy-backend/api/manager/model/list', param);
  }


  //目录管理列表
  public fetchFolderList(param: Dict<any>): Promise<any> {
    return this.http.post('/wecom-buddy-backend/api/manager/folder/list', param);
  }

  //目录管理详情
  public fetchFolderDetail(param: Dict<any>): Promise<any> {
    return this.http.get('/wecom-buddy-backend/api/manager/folder/detail', param);
  }

  //目录管理保存
  public saveFolder(param: Dict<any>): Promise<any> {
    return this.http.post('/wecom-buddy-backend/api/manager/folder/save', param);
  }

  //目录管理删除
  public deleteFolder(param: Dict<any>): Promise<any> {
    return this.http.delete(`/wecom-buddy-backend/api/manager/folder/del?id=${param.id}`);
  }

  //目录是否有关联文章
  public fetchFolderRelationArticle(param: Dict<any>): Promise<any> {
    return this.http.get('/wecom-buddy-backend/api/manager/folder/relation/article', param);
  }

  //图片上传
  public uploadImage(formData: FormData): Promise<any> {
    return this.http.post('/wecom-buddy-backend/api/v2/file/uploadImage', formData);
  }

  //所属封面下拉列表
  public fetchCoverOption(param: Dict<any>): Promise<any> {
    return this.http.get('/wecom-buddy-backend/api/manager/cover/option', param);
  }

  //所属筛选后的封面下拉列表（被选择过的封面无法被新增）
  public fetchFilteredCoverOption(): Promise<any> {
    return this.http.get('/wecom-buddy-backend/api/manager/folder/cover/option');
  }
  

  //kpi备注列表
  public fetchKpiRemarks(param: Dict<any>): Promise<any> {
    return this.http.post('/wecom-buddy-backend/api/manager/kpi/remarks/list', param);
  }

  //kpi备注详情
  public fetchKpiRemarkDetail(param: Dict<any>): Promise<any> {
    return this.http.get(`/wecom-buddy-backend/api/manager/kpi/remarks/detail?id=${param.id}`);
  }


  //kpi备注保存
  public saveKpiRemark(param: Dict<any>): Promise<any> {
    return this.http.post('/wecom-buddy-backend/api/manager/kpi/remarks/add', param);
  }

  //kpi备注更新
  public updateKpiRemark(param: Dict<any>): Promise<any> {
    return this.http.post('/wecom-buddy-backend/api/manager/kpi/remarks/upd', param);
  }

  //kpi备注删除
  public deleteKpiRemark(param: Dict<any>): Promise<any> {
    return this.http.delete(`/wecom-buddy-backend/api/manager/kpi/remarks/del?id=${param.id}`);
  }

  //kpi主目录管理列表
  public fetchKpiFolderList(param: Dict<any>): Promise<any> {
    return this.http.post('/wecom-buddy-backend/api/manager/kpi/group/list', param);
  }

  //kpi主目录管理新增
  public saveKpiFolder(param: Dict<any>): Promise<any> {
    return this.http.post('/wecom-buddy-backend/api/manager/kpi/group/add', param);
  }

  //kpi主目录管理删除
  public deleteKpiFolder(param: Dict<any>): Promise<any> {
    return this.http.delete(`/wecom-buddy-backend/api/manager/kpi/group/del?id=${param.id}`);
  }

  //kpi主目录管理详情
  public fetchKpiFolderDetail(param: Dict<any>): Promise<any> {
    return this.http.get(`/wecom-buddy-backend/api/manager/kpi/group/detail?id=${param.id}`);
  }

  //kpi主目录管理更新
  public updateKpiFolder(param: Dict<any>): Promise<any> {
    return this.http.post('/wecom-buddy-backend/api/manager/kpi/group/upd', param);
  }

  //kpi主目录查看是否有子目录列表 
  public fetchKpiFolderChildList(param: Dict<any>): Promise<any> {
    return this.http.get(`/wecom-buddy-backend/api/manager/kpi/group/folder/list?id=${param.id}`);
  }

  //kpi子目录修改保存接口
  public saveKpiSubFolder(param: Dict<any>): Promise<any> {
    return this.http.post('/wecom-buddy-backend/api/manager/kpi/folder/save', param);
  }

  //kpi内容管理列表
  public fetchKpiContentList(param: Dict<any>): Promise<any> {
    return this.http.post('/wecom-buddy-backend/api/manager/kpi/content/list', param);
  }
  
  //kpi内容管理详情
  public fetchKpiContentDetail(param: Dict<any>): Promise<any> {
    return this.http.get(`/wecom-buddy-backend/api/manager/kpi/content/detail?id=${param.id}`);
  }

  //kpi内容管理保存
  public saveKpiContent(param: Dict<any>): Promise<any> {
    return this.http.post('/wecom-buddy-backend/api/manager/kpi/content/save', param);
  }


  //kpi内容管理页面需要的子目录下拉列表
  public fetchKpiFolderOption(param: Dict<any>): Promise<any> {
    return this.http.get('/wecom-buddy-backend/api/manager/kpi/folder/option', param);
  }

  //kpi内容管理删除
  public deleteKpiContent(param: Dict<any>): Promise<any> {
    return this.http.delete(`/wecom-buddy-backend/api/manager/kpi/content/del?id=${param.id}`);
  }

  //kpi子目录删除时查找是否有关联考核项
  public fetchKpiFolderRelationContent(param: Dict<any>): Promise<any> {
    return this.http.get('/wecom-buddy-backend/api/manager/kpi/folder/exist/content', param);
  }

  //目录下拉
  public fetchFolderOption(param: Dict<any>): Promise<any> {
    return this.http.get('/wecom-buddy-backend/api/manager/folder/option', param);
  }

  //用户行为日志列表新
  public fetchUserActionLog(param: Dict<any>): Promise<any> {
    return this.http.post('/wecom-buddy-backend/api/manager/user/history/list', param);
  }

  //用户行为日志列表导出新
  public async exportUserActionLogToExcel(param: Dict<any>, name: string): Promise<any> {
    const resType: AxiosRequestConfig = { responseType: 'blob' };
    const blob = await this.http.post('/wecom-buddy-backend/api/manager/user/history/export/excel', param,null,resType);
    this.http.triggerDownload(blob, '/wecom-buddy-backend/api/user/admin/export/excel?' , name + '.xlsx');
  }

  //通知管理新增
  public addNotify(param: Dict<any>, conf: any): Promise<any> {
    return this.http.post('/wecom-buddy-backend/api/manager/notify/add', param, null, conf);
  }

  //通知管理列表
  public fetchNotifyList(param: Dict<any>): Promise<any> {    
    return this.http.post('/wecom-buddy-backend/api/manager/notify/list', param);
  }

  //通知列表更新
  public updateNotify(param: Dict<any>, conf: any): Promise<any> {
    return this.http.post('/wecom-buddy-backend/api/manager/notify/upd', param, null, conf);
  }

  //通知列表详情
  public fetchNotifyDetail(param: Dict<any>): Promise<any> {
    return this.http.get('/wecom-buddy-backend/api/manager/notify/detail', param);
  }

  //通知列表删除
  public deleteNotify(param: Dict<any>, conf?: AxiosRequestConfig): Promise<any> {
    return this.http.delete(`/wecom-buddy-backend/api/manager/notify/del?id=${param.id}`);
  }
  
  //权限管理列表
  public fetchPermissionList(param: Dict<any>): Promise<any> {
    return this.http.post('/wecom-buddy-backend/api/manager/permission/list', param);
  }
  
  //权限管理新增
  public addPermission(param: Dict<any>): Promise<any> {
    return this.http.post('/wecom-buddy-backend/api/manager/permission/add', param);
  }

  //权限管理更新
  public updatePermission(param: Dict<any>): Promise<any> {
    return this.http.post('/wecom-buddy-backend/api/manager/permission/upd', param);  
  }

  //权限管理详情
  public fetchPermissionDetail(param: Dict<any>): Promise<any> {
    return this.http.get('/wecom-buddy-backend/api/manager/permission/detail', param);
  }

  //权限管理删除
  public deletePermission(param: Dict<any>): Promise<any> {
    return this.http.delete(`/wecom-buddy-backend/api/manager/permission/del?id=${param.id}`);
  }

  //权限管理获取封面列表
  public fetchAppCoverOption(): Promise<any> {
    return this.http.get('/wecom-buddy-backend/api/manager/permission/appCover/option');
  }


  //反馈列表
  public fetchFeedbackList(param: Dict<any>): Promise<any> {
    return this.http.post('/wecom-buddy-backend/api/v2/manage/user/feedback/list', param);
  }

  //反馈详情
  public fetchFeedbackDetail(param: Dict<any>): Promise<any> {
    return this.http.get(`/wecom-buddy-backend/api/v2/manage/user/feedback/detail?id=${param.id}`);
  }

  //回复反馈
  public replyFeedback(param: Dict<any>): Promise<any> {
    return this.http.post('/wecom-buddy-backend/api/v2/manage/user/feedback/reply/save?operation=SAVE', param);
  }

  //反馈回复更新，post请求，operation为params传进来的参数
  public saveAndNotifyFeedbackReply(param: Dict<any>): Promise<any> {
    return this.http.post(`/wecom-buddy-backend/api/v2/manage/user/feedback/reply/save?operation=SAVE_AND_NOTIFY`, param);
  }
}
